import { render, staticRenderFns } from "./TSZ_Validacion.vue?vue&type=template&id=d80488cc&scoped=true&"
import script from "./TSZ_Validacion.vue?vue&type=script&lang=js&"
export * from "./TSZ_Validacion.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Validacion.vue?vue&type=style&index=0&id=d80488cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80488cc",
  null
  
)

export default component.exports